import { Outlet } from 'react-router-dom';
import { ForceUpdateModal } from '../components/ForceUpdateModal';
import { RollbackModal } from '../components/RollbackModal';
import { useAutoUpdate } from '../hooks/useAutoUpdate';

export function RootLayout() {
  const { required, requiredVersion, currentVersion, rollback } = useAutoUpdate();

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {required && (
        <ForceUpdateModal requiredVersion={requiredVersion} currentVersion={currentVersion} />
      )}
      {rollback.active && (
        <RollbackModal
          rollbackVersion={rollback.rollbackVersion}
          currentVersion={rollback.currentVersion}
        />
      )}
      <Outlet />
    </div>
  );
}
